var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlans({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-plans_module",
    transform: "translate(-24 -152)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_202",
    "data-name": "Rectangle 202",
    width: 48,
    height: 48,
    transform: "translate(24 152)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Component_60_2",
    "data-name": "Component 60 \\u2013 2",
    transform: "translate(39 167.514)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M2,3V21.387H23.631V3ZM4.163,5.163H21.468v14.06H4.163ZM19.305,7.326,17.142,9.489,16.06,8.408,14.979,9.489l2.163,2.163,3.245-3.245ZM5.245,8.408v2.163H13.9V8.408Zm14.06,4.326L17.142,14.9,16.06,13.816,14.979,14.9l2.163,2.163,3.245-3.245ZM5.245,13.816v2.163H13.9V13.816Z",
    transform: "translate(-2 -3)",
    fill: "#767493"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlans);
export default __webpack_public_path__ + "static/media/icon_plans.bd5982a0453e277f9717b91390f47829.svg";
export { ForwardRef as ReactComponent };